import { render } from "./founder_dashboard.html?vue&type=template&id=19e7c379&external"
import script from "./founder_dashboard.js?vue&type=script&lang=js&external"
export * from "./founder_dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__